import React, { useEffect, useState } from "react"
import { create_keyword_string } from "./utils"
export const Skyscraper = ({
  adbutler_page_id,
  ressort = "baumagazin",
  num_placements,
  tags = [],
  topic = "",
}) => {
  let current_ad_index = 0
  const keyword_string = create_keyword_string({
    tags,
    ressort,
    topic,
  })

  const [state, setState] = useState({
    banner_id: "",
    body: "",
    imageURL: "",
    imageWidth: "",
    imageHeight: "",
    link_target: "",
    redirectURL: "",
    tracking_pixel: "",
  })

  const adbutlerIds = {
    baumagazin: 431531,
    galabau: 431532,
    umweltbau: 431533,
  }

  const get_skyscraper = () =>
    fetch("https://servedbyadbutler.com/adserve", {
      method: "POST",
      body: JSON.stringify({
        ID: "169218",
        size: "0x0",
        setID: adbutlerIds[ressort],
        type: "json",
        pid: adbutler_page_id || undefined,
        place: current_ad_index % num_placements,
        kw: keyword_string,
      }),
    })
      .then((response) => response.json()) // parse JSON from request
      .then((resultData) => {
        if (resultData.status !== "NO_ADS") {
          setState({
            banner_id: resultData?.placements?.placement_1.banner_id,
            body: resultData?.placements?.placement_1.body,
            imageURL: resultData?.placements?.placement_1.image_url,
            imageWidth: resultData?.placements?.placement_1.width,
            imageHeight: resultData?.placements?.placement_1.height || "",
            link_target: resultData?.placements?.placement_1.target,
            redirectURL: resultData?.placements?.placement_1.redirect_url,
            tracking_pixel: resultData?.placements?.placement_1.tracking_pixel,
          })
        }
      })

  let update_interval
  const start_update_timer = () =>
    (update_interval = setInterval(() => {
      current_ad_index++
      if (current_ad_index <= num_placements * 2) {
        get_skyscraper()
      }
    }, 27000))

  useEffect(() => {
    if (!!window && window?.innerWidth >= 1250) {
      get_skyscraper()
      if (num_placements > 1) {
        start_update_timer()
        document.addEventListener("visibilitychange", () => {
          if (document.hidden) {
            clearInterval(update_interval)
          } else {
            start_update_timer()
          }
        })
      }
    }
    return () => clearInterval(update_interval)
  }, []) // eslint-disable-line

  if (state.banner_id === "521190747") {
    document.getElementById("___gatsby").style.backgroundColor = "#000000"
  }
  return (
    <div data-nosnippet>
      {state.body || state.imageURL ? (
        <div className={`skyscraper-wrapper`}>
          <div className="skyscraper-ad">
            <div style={{ display: "flex" }}>
              <div
                style={{
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                {state.body ? (
                  <div>
                    <div dangerouslySetInnerHTML={{ __html: state.body }}></div>
                    <div className="ad-disclaimer">Anzeige</div>
                  </div>
                ) : state.imageURL ? (
                  <div>
                    <a
                      href={state.redirectURL}
                      target={state.link_target}
                      rel="noopener noreferrer"
                      title={`Anzeige`}
                    >
                      <img
                        src={state.imageURL}
                        alt={`Anzeige`}
                        title={`Anzeige`}
                        width={state.imageWidth || "auto"}
                        height={state.imageHeight || "auto"}
                        style={{ maxWidth: "300px" }}
                      />
                    </a>
                    <div className="ad-disclaimer">Anzeige</div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {!!state?.tracking_pixel ? (
        <img
          alt=""
          src={state?.tracking_pixel}
          border="0"
          width="1"
          height="1"
        />
      ) : null}
    </div>
  )
}
